import { THIRD_PARTY_NETWORK_PROVIDERS } from '@provision/attribute-utils';
import { SAVE_DEBOUNCE_DELAY } from 'src/constants/delays';

interface Option {
  id: string;
  label: string;
}

const urlPattern =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

const sort = (a: Option, b: Option): number => a.label.localeCompare(b.label);

export const primaryEquipmentLocation = [
  { label: 'Attic', id: 'location_attic' },
  { label: 'Art Gallery', id: 'location_art_gallery' },
  { label: 'Aviation Hangar', id: 'location_aviation_hangar' },
  { label: 'Balcony', id: 'location_balcony' },
  { label: 'Basement', id: 'location_basement' },
  { label: 'Bathroom', id: 'location_bathroom' },
  { label: 'Bonus Room', id: 'location_bonus_room' },
  { label: 'Butler Pantry', id: 'location_butler_pantry' },
  { label: 'Break Room', id: 'location_break_room' },
  { label: 'Cabana', id: 'location_cabana' },
  { label: 'Cabinet', id: 'location_cabinet' },
  { label: 'Boat House', id: 'location_boat_house' },
  { label: 'Bowling Alley', id: 'location_bowling_alley' },
  { label: 'Coach House', id: 'location_coach_house' },
  { label: 'Conference Room', id: 'location_conference_room' },
  { label: 'Crawlspace', id: 'location_crawlspace' },
  { label: 'Cigar Lounge', id: 'location_cigar_lounge' },
  { label: 'Den', id: 'location_den' },
  { label: 'Gallery', id: 'location_gallery' },
  { label: 'Exercise Room', id: 'location_exercise_room' },
  { label: 'Family', id: 'location_family' },
  { label: 'Foyer', id: 'location_foyer' },
  { label: 'Front Closet', id: 'location_front_closet' },
  { label: 'Game Room', id: 'location_game_room' },
  { label: 'Garage', id: 'location_garage' },
  { label: 'Golf Simulator', id: 'location_golf_simulator' },
  { label: 'Greenhouse', id: 'location_greenhouse' },
  { label: 'Great Room', id: 'location_great_room' },
  { label: 'Guest House', id: 'location_guest_house' },
  { label: 'Guest Suite', id: 'location_guest_suite' },
  { label: 'Gym', id: 'location_gym' },
  { label: 'Hallway', id: 'location_hallway' },
  { label: 'Helipad', id: 'location_helipad' },
  { label: 'IT Room', id: 'location_it_room' },
  { label: 'Kids Room', id: 'location_kids_room' },
  { label: 'Kitchen', id: 'location_kitchen' },
  { label: 'Laundry', id: 'location_laundry' },
  { label: 'Library', id: 'location_library' },
  { label: 'Living', id: 'location_living' },
  { label: 'Lobby', id: 'location_lobby' },
  { label: 'Man Cave', id: 'location_man_cave' },
  { label: 'Master Bed', id: 'location_master_bed' },
  { label: 'Master Closet', id: 'location_master_closet' },
  { label: 'Mechanical Room', id: 'location_mechanical_room' },
  { label: 'Media Room', id: 'location_media_room' },
  { label: 'Mudroom', id: 'location_mudroom' },
  { label: 'Office/Study', id: 'location_office/study' },
  { label: 'Other - In Notes', id: 'location_other' },
  { label: 'Other Bed', id: 'location_other_bed' },
  { label: 'Other Closet', id: 'location_other_closet' },
  { label: 'Other Conference Room', id: 'location_other_conference_room' },
  { label: 'Pantry', id: 'location_pantry' },
  { label: 'Play Room', id: 'location_play_room' },
  { label: 'Pool House', id: 'location_pool_house' },
  { label: 'Porch', id: 'location_porch' },
  { label: 'Recording Studio', id: 'location_recording_studio' },
  { label: 'Rack Closet', id: 'location_rack_closet' },
  { label: 'Rack Room', id: 'location_rack_room' },
  { label: 'Reception Area', id: 'location_reception_area' },
  { label: 'Rooftop', id: 'location_rooftop' },
  { label: 'Safe Room', id: 'location_safe_room' },
  { label: 'Sauna', id: 'location_sauna' },
  { label: 'Server Room', id: 'location_server_room' },
  { label: 'Shed', id: 'location_shed' },
  { label: 'Spa', id: 'location_spa' },
  { label: 'Storage Closet', id: 'location_storage_closet' },
  { label: 'Storage Room', id: 'location_storage_room' },
  { label: 'Studio', id: 'location_studio' },
  { label: 'Sunroom', id: 'location_sunroom' },
  { label: 'Theater', id: 'location_theater' },
  { label: 'Terrace', id: 'location_terrace' },
  { label: 'Utility Room', id: 'location_utility_room' },
  { label: 'Under Stairs', id: 'location_under_stairs' },
  { label: 'Wine Cellar', id: 'location_wine_cellar' },
  { label: 'Wine Tasting Room', id: 'location_wine_tasting_room' },
  { label: 'Wellness Suite', id: 'location_wellness_suite' },
  { label: 'Workshop', id: 'location_workshop' },
].sort(sort);
export const networkLocation = [
  { label: 'Attic', id: 'modem_attic' },
  { label: 'Art Gallery', id: 'modem_art_gallery' },
  { label: 'Aviation Hangar', id: 'modem_aviation_hangar' },
  { label: 'Balcony', id: 'modem_balcony' },
  { label: 'Basement', id: 'modem_basement' },
  { label: 'Bathroom', id: 'modem_bathroom' },
  { label: 'Bonus Room', id: 'modem_bonus_room' },
  { label: 'Break Room', id: 'modem_break_room' },
  { label: 'Cabana', id: 'modem_cabana' },
  { label: 'Cabinet', id: 'modem_cabinet' },
  { label: 'Boat House', id: 'modem_boat_house' },
  { label: 'Bowling Alley', id: 'modem_bowling_alley' },
  { label: 'Coach House', id: 'modem_coach_house' },
  { label: 'Conference Room', id: 'modem_conference_room' },
  { label: 'Crawlspace', id: 'modem_crawlspace' },
  { label: 'Cigar Lounge', id: 'modem_cigar_lounge' },
  { label: 'Den', id: 'modem_den' },
  { label: 'Gallery', id: 'modem_gallery' },
  { label: 'Exercise Room', id: 'modem_exercise_room' },
  { label: 'Family', id: 'modem_family' },
  { label: 'Foyer', id: 'modem_foyer' },
  { label: 'Front Closet', id: 'modem_front_closet' },
  { label: 'Game Room', id: 'modem_game_room' },
  { label: 'Garage', id: 'modem_garage' },
  { label: 'Golf Simulator', id: 'modem_golf_simulator' },
  { label: 'Greenhouse', id: 'modem_greenhouse' },
  { label: 'Great Room', id: 'modem_great_room' },
  { label: 'Guest House', id: 'modem_guest_house' },
  { label: 'Guest Suite', id: 'modem_guest_suite' },
  { label: 'Gym', id: 'modem_gym' },
  { label: 'Hallway', id: 'modem_hallway' },
  { label: 'Helipad', id: 'modem_helipad' },
  { label: 'IT Room', id: 'modem_it_room' },
  { label: 'Kids Room', id: 'modem_kids_room' },
  { label: 'Kitchen', id: 'modem_kitchen' },
  { label: 'Library', id: 'modem_library' },
  { label: 'Living', id: 'modem_living' },
  { label: 'Lobby', id: 'modem_lobby' },
  { label: 'Laundry Room', id: 'modem_laundry_room' },
  { label: 'Man Cave', id: 'modem_man_cave' },
  { label: 'Master Bed', id: 'modem_master_bed' },
  { label: 'Master Closet', id: 'modem_master_closet' },
  { label: 'Mechanical Room', id: 'modem_mechanical_room' },
  { label: 'Media Room', id: 'modem_media_room' },
  { label: 'Mudroom', id: 'modem_mudroom' },
  { label: 'Office/Study', id: 'modem_office/study' },
  { label: 'Other - In Notes', id: 'modem_other' },
  { label: 'Other Bed', id: 'modem_other_bed' },
  { label: 'Other Closet', id: 'modem_other_closet' },
  { label: 'Other Conference Room', id: 'modem_other_conference_room' },
  { label: 'Pantry', id: 'modem_pantry' },
  { label: 'Play Room', id: 'modem_play_room' },
  { label: 'Pool House', id: 'modem_pool_house' },
  { label: 'Porch', id: 'modem_porch' },
  { label: 'Recording Studio', id: 'modem_recording_studio' },
  { label: 'Rack Closet', id: 'modem_rack_closet' },
  { label: 'Rack Room', id: 'modem_rack_room' },
  { label: 'Reception Area', id: 'modem_reception_area' },
  { label: 'Rooftop', id: 'modem_rooftop' },
  { label: 'Safe Room', id: 'modem_safe_room' },
  { label: 'Sauna', id: 'modem_sauna' },
  { label: 'Server Room', id: 'modem_server_room' },
  { label: 'Shed', id: 'modem_shed' },
  { label: 'Spa', id: 'modem_spa' },
  { label: 'Storage Closet', id: 'modem_storage_closet' },
  { label: 'Storage Room', id: 'modem_storage_room' },
  { label: 'Studio', id: 'modem_studio' },
  { label: 'Sunroom', id: 'modem_sunroom' },
  { label: 'Theater', id: 'modem_theater' },
  { label: 'Terrace', id: 'modem_terrace' },
  { label: 'Utility Room', id: 'modem_utility_room' },
  { label: 'Under Stairs', id: 'modem_under_stairs' },
  { label: 'Wine Cellar', id: 'modem_wine_cellar' },
  { label: 'Wine Tasting Room', id: 'modem_wine_tasting_room' },
  { label: 'Wellness Suite', id: 'modem_wellness_suite' },
  { label: 'Workshop', id: 'modem_workshop' },
  { label: 'With Primary Equipment', id: 'modem_with_primary_equipment' },
].sort(sort);
export const thirdPartyNetworkProvider = [...THIRD_PARTY_NETWORK_PROVIDERS].sort(sort);
export const wiredNetworkBrand = [
  {
    label: 'Supported By 3rd Party',
    id: 'wiredbrand_supported_by_3rd_party',
  },
  { label: 'Access Networks', id: 'wiredbrand_access_networks' },
  { label: 'Aerohive', id: 'wiredbrand_aerohive' },
  { label: 'Apple AirPort', id: 'wiredbrand_apple_airport' },
  { label: 'Aruba Networks', id: 'wiredbrand_aruba_networks' },
  { label: 'Araknis (SnapAV)', id: 'wiredbrand_araknis_snapav' },
  { label: 'Arista Networks', id: 'wiredbrand_arista_networks' },
  { label: 'Belkin', id: 'wiredbrand_belkin' },
  { label: 'Cisco', id: 'wiredbrand_cisco' },
  { label: 'Cradlepoint', id: 'wiredbrand_cradlepoint' },
  { label: 'Extreme Networks', id: 'wiredbrand_extreme_networks' },
  { label: 'D-Link', id: 'wiredbrand_d-link' },
  { label: 'Eero', id: 'wiredbrand_eero' },
  { label: 'EnGenius', id: 'wiredbrand_engenius' },
  { label: 'Firewalla', id: 'wiredbrand_firewalla' },
  { label: 'Fortinet', id: 'wiredbrand_fortinet' },
  { label: 'GrandStream', id: 'wired_grandstream' },
  { label: 'Island Router', id: 'wired_island_router' },
  { label: 'Juniper', id: 'wiredbrand_juniper' },
  { label: 'Linksys', id: 'wiredbrand_linksys' },
  { label: 'Luxul', id: 'wiredbrand_luxul' },
  { label: 'Meraki', id: 'wiredbrand_meraki' },
  { label: 'MikroTik', id: 'wiredbrand_microtik' },
  { label: 'Netgear', id: 'wiredbrand_netgear' },
  { label: 'Netgear Orbi Pro', id: 'wiredbrand_netgear_orbi_pro' },
  { label: 'Peplink', id: 'wiredbrand_peplink' },
  { label: 'Pakedge', id: 'wiredbrand_pakedge' },
  { label: 'Ruckus', id: 'wiredbrand_ruckus' },
  { label: 'Sophos', id: 'wiredbrand_sophos' },
  { label: 'Starlink', id: 'wiredbrand_starlink' },
  { label: 'TP-Link', id: 'wiredbrand_tp-link' },
  { label: 'TrendNET', id: 'wiredbrand_trendnet' },
  { label: 'Ubiquiti', id: 'wiredbrand_ubiquiti' },
  { label: 'Zyxel', id: 'wiredbrand_zyxel' },
  { label: 'WatchGuard', id: 'wiredbrand_watchguard' },
  { label: 'Other - In Notes', id: 'wiredbrand_other' },
  { label: 'XFINITY From Comcast', id: 'wiredbrand_xfinity_from_comcast' },
  { label: 'ISP Brand', id: 'wiredbrand_isp_brand' },
].sort(sort);
export const wirelessNetworkBrand = [
  {
    label: 'Supported By 3rd Party',
    id: 'wirelessbrand_supported_by_3rd_party',
  },
  { label: 'Access Networks', id: 'wirelessbrand_access_networks' },
  { label: 'Aerohive', id: 'wirelessbrand_aerohive' },
  { label: 'Apple AirPort', id: 'wirelessbrand_apple_airport' },
  { label: 'Aruba Networks', id: 'wirelessbrand_aruba_networks' },
  { label: 'Araknis (SnapAV)', id: 'wirelessbrand_araknis_snapav' },
  { label: 'Arista Networks', id: 'wirelessbrand_arista_networks' },
  { label: 'Belkin', id: 'wirelessbrand_belkin' },
  { label: 'Cisco', id: 'wirelessbrand_cisco' },
  { label: 'D-Link', id: 'wirelessbrand_d-link' },
  { label: 'Eero', id: 'wirelessbrand_eero' },
  { label: 'EnGenius', id: 'wirelessbrand_engenius' },
  { label: 'Extreme Networks', id: 'wirelessbrand_extreme_networks' },
  { label: 'Fortinet', id: 'wirelessbrand_fortinet' },
  { label: 'GrandStream', id: 'wireless_grandstream' },
  { label: 'Juniper', id: 'wirelessbrand_juniper' },
  { label: 'Linksys', id: 'wirelessbrand_linksys' },
  { label: 'Luxul', id: 'wirelessbrand_luxul' },
  { label: 'Meraki', id: 'wirelessbrand_meraki' },
  { label: 'MikroTik', id: 'wirelessbrand_microtik' },
  { label: 'Netgear', id: 'wirelessbrand_netgear' },
  { label: 'Netgear Orbi Pro', id: 'wirelessbrand_netgear_orbi_pro' },
  { label: 'Peplink', id: 'wirelessbrand_peplink' },
  { label: 'Pakedge', id: 'wirelessbrand_pakedge' },
  { label: 'Ruckus', id: 'wirelessbrand_ruckus' },
  { label: 'Sophos', id: 'wirelessbrand_sophos' },
  { label: 'Starlink', id: 'wirelessbrand_starlink' },
  { label: 'TP-Link', id: 'wirelessbrand_tp-link' },
  { label: 'TrendNET', id: 'wirelessbrand_trendnet' },
  { label: 'Ubiquiti', id: 'wirelessbrand_ubiquiti' },
  { label: 'Zyxel', id: 'wirelessbrand_zyxel' },
  { label: 'WatchGuard', id: 'wirelessbrand_watchguard' },
  { label: 'Other - In Notes', id: 'wirelessbrand_other' },
  {
    label: 'XFINITY From Comcast',
    id: 'wirelessbrand_xfinity_from_comcast',
  },
  { label: 'ISP Brand', id: 'wirelessbrand_isp_brand' },
].sort(sort);
export const controlSystemBrand = [
  { label: 'AMX', id: 'control_amx' },
  { label: 'Bond Bridge', id: 'control_bond_bridge' },
  { label: 'Black Nova', id: 'control_black_nova' },
  { label: 'Control4', id: 'control_control4' },
  { label: 'Crestron', id: 'control_crestron' },
  { label: 'Crestron Home', id: 'control_crestron_home' },
  { label: 'Elan (Nice)', id: 'control_elan_nice' },
  { label: 'Elan', id: 'control_elan' },
  { label: 'Fibaro', id: 'control_fibaro' },
  { label: 'Identicard', id: 'control_identicard' },
  { label: 'Josh.ai', id: 'control_joshai' },
  { label: 'KNX', id: 'control_knx' },
  { label: 'Loxone', id: 'control_loxone' },
  { label: 'Logitech', id: 'control_logitech' },
  { label: 'Nice Home Management', id: 'control_nice_home_management' },
  { label: 'Not Present', id: 'control_not_present' },
  { label: 'Nuvo', id: 'control_nuvo' },
  { label: 'Other - In Notes', id: 'control_other' },
  { label: 'ProControls', id: 'control_procontrols' },
  { label: 'RTI', id: 'control_rti' },
  { label: 'Schneider Electric Wiser', id: 'control_schneider_electric_wiser' },
  { label: 'Savant', id: 'control_savant' },
  { label: 'URC Total Control', id: 'control_urc_total_control' },
  {
    label: 'Supported By 3rd Party',
    id: 'control_supported_by_3rd_party',
  },
  {
    label: 'Universal Remote Control',
    id: 'control_universal_remote_control',
  },
].sort(sort);
export const internetServiceProvider = [
  { label: 'Aerux', id: 'internet_aerux' },
  { label: 'Armstrong', id: 'internet_armstrong' },
  { label: '3 Rivers Communications', id: 'internet_3_rivers_communications' },
  { label: 'AT&T Fiber', id: 'internet_att_fiber' },
  { label: 'AT&T Uverse', id: 'internet_att_uverse' },
  {
    label: 'Allwest Communications',
    id: 'internet_allwest_communications',
  },
  { label: 'Astound Broadband', id: 'internet_astound_broadband' },
  { label: 'Bell', id: 'internet_bell' },
  { label: 'Breezeline', id: 'internet_breezeline' },
  {
    label: 'Blue Ridge Communications',
    id: 'internet_blue_ridge_communications',
  },
  { label: 'C Spire Fiber', id: 'internet_c_spire_fiber' },
  { label: 'Cable ONE', id: 'internet_cable_one' },
  { label: 'CenturyLink', id: 'internet_centurylink' },
  { label: 'Charter Spectrum', id: 'internet_charter_spectrum' },
  { label: 'Cincinnati Bell', id: 'internet_cincinnati_bell' },
  { label: 'Cogeco', id: 'internet_cogeco' },
  { label: 'Comcast Business', id: 'internet_comcast_business' },
  {
    label: 'Consolidated Communications',
    id: 'internet_consolidated_communications',
  },
  { label: 'Cox Business', id: 'internet_cox_business' },
  { label: 'Cox Communications', id: 'internet_cox_communications' },
  { label: 'Delta Cable', id: 'internet_delta_cable' },
  { label: 'DirecTV', id: 'internet_directv' },
  { label: 'Eatel', id: 'internet_eatel' },
  { label: 'Eastlink', id: 'internet_eastlink' },
  { label: 'Fidelity', id: 'internet_fidelity' },
  {
    label: 'Frontier Communications',
    id: 'internet_frontier_communications',
  },
  { label: 'Fidium Fiber', id: 'internet_fidium_fiber' },
  { label: 'GigaMonster', id: 'internet_gigamonster' },
  { label: 'Google Fiber', id: 'internet_google_fiber' },
  { label: 'Grizzly Broadband', id: 'internet_grizzly_broadband' },
  { label: 'GVTC', id: 'internet_gvtc' },
  { label: 'GVTC Fiber', id: 'internet_gvtc_fiber' },
  { label: 'Hargray', id: 'internet_hargray' },
  { label: 'Hawaiian Telcom', id: 'internet_hawaiian_telcom' },
  {
    label: 'Hotwire Communications',
    id: 'internet_hotwire_communications',
  },
  { label: 'EarthLink', id: 'internet_earthlink' },
  { label: 'HughesNet', id: 'internet_hughesnet' },
  { label: 'Interbel', id: 'internet_interbel' },
  { label: 'IQ Fiber', id: 'internet_iq_fiber' },
  { label: 'iWisp', id: 'internet_iwisp' },
  { label: 'Altafiber', id: 'internet_altafiber' },
  { label: 'LUS Fiber', id: 'internet_lus_fiber' },
  { label: 'Maverix Broadband', id: 'internet_maverix_broadband' },
  { label: 'Midco', id: 'internet_midco' },
  { label: 'Mediacom Cable', id: 'internet_mediacom_cable' },
  { label: 'Metronet', id: 'internet_metronet' },
  { label: 'Montana Sky', id: 'internet_montana_sky' },
  { label: 'Mountain Max', id: 'internet_mountain_max' },
  { label: 'Not Present', id: 'internet_not_present' },
  {
    label: 'Optimum By Cablevision',
    id: 'internet_optimum_by_cablevision',
  },
  { label: 'Optimum Fiber', id: 'internet_optimum_fiber' },
  { label: 'Other - In Notes', id: 'internet_other' },
  { label: 'Kinetic by Windstream', id: 'internet_kinetic_by_windstream' },
  { label: 'Ponderosa', id: 'internet_ponderosa' },
  { label: 'Quantum Fiber', id: 'internet_quantum_fiber' },
  { label: 'Ranch', id: 'internet_ranch' },
  { label: 'RCN', id: 'internet_rcn' },
  { label: 'Rise Broadband', id: 'internet_rise_broadband' },
  { label: 'Rogers', id: 'internet_rogers' },
  { label: 'Sparklight', id: 'internet_sparklight' },
  { label: 'Shaw', id: 'internet_shaw' },
  {
    label: 'Suddenlink Communications',
    id: 'internet_suddenlink_communications',
  },
  {
    label: 'Supported By 3rd Party',
    id: 'internet_supported_by_3rd_party',
  },
  { label: 'Sonic', id: 'internet_sonic' },
  { label: 'TDS Telecom', id: 'internet_tds_telecom' },
  { label: 'Telus', id: 'internet_telus' },
  { label: 'Ting', id: 'internet_ting' },
  { label: 'Verizon 5G Home Internet', id: 'internet_verizon_5g_home_internet' },
  { label: 'Verizon Fios', id: 'internet_verizon_fios' },
  { label: 'Viasat', id: 'internet_viasat' },
  { label: 'Wave Broadband', id: 'internet_wave_broadband' },
  { label: 'Windstream', id: 'internet_windstream' },
  { label: 'WOW!', id: 'internet_wow' },
  { label: 'Southern Light', id: 'internet_southernlight' },
  { label: 'Starlink', id: 'internet_starlink' },
  { label: 'Frontier Fiber', id: 'internet_frontier_fiber' },
  { label: 'Summit Broadband', id: 'internet_summit_broadband' },
  { label: 'Surestream Fiber', id: 'internet_surestream_fiber' },
  { label: 'Visionary Broadband', id: 'internet_visionary_broadband' },
  { label: 'Viya', id: 'internet_viya' },
  { label: 'Wicked Fast', id: 'internet_wicked_fast' },
  { label: 'Ezee Fiber', id: 'internet_ezee_fiber' },
  { label: 'Tachus', id: 'internet_tachus' },
  { label: 'XFINITY From Comcast', id: 'internet_xfinity_from_comcast' },
  { label: 'Xplornet', id: 'internet_xplornet' },
  { label: 'T-Mobile', id: 'internet_tmobile' },
  { label: 'Ziply Fiber', id: 'internet_ziply_fiber' },
  { label: 'Brightspeed', id: 'internet_brightspeed' },
].sort(sort);
export const tvServiceProvider = [
  { label: 'Armstrong', id: 'tv_armstrong' },
  { label: 'AT&T Uverse', id: 'tv_att_uverse' },
  { label: 'Astound Broadband', id: 'tv_astound_broadband' },
  { label: 'Bell', id: 'tv_bell' },
  {
    label: 'Blue Ridge Communications',
    id: 'tv_blue_ridge_communications',
  },
  { label: 'C Spire Fiber', id: 'tv_c_spire_fiber' },
  { label: 'Cable ONE', id: 'tv_cable_one' },
  { label: 'CenturyLink', id: 'tv_centurylink' },
  { label: 'Charter Spectrum', id: 'tv_charter_spectrum' },
  { label: 'Cincinnati Bell', id: 'tv_cincinnati_bell' },
  { label: 'Cogeco', id: 'tv_cogeco' },
  {
    label: 'Consolidated Communications',
    id: 'tv_consolidated_communications',
  },
  { label: 'Cox Communications', id: 'tv_cox_communications' },
  { label: 'Delta Cable', id: 'tv_delta_cable' },
  { label: 'DirecTV', id: 'tv_directv' },
  { label: 'Dish Network', id: 'tv_dish_network' },
  { label: 'FuboTV', id: 'tv_fubotv' },
  { label: 'Frontier Communications', id: 'tv_frontier_communications' },
  { label: 'Google Fiber', id: 'tv_google_fiber' },
  { label: 'Hargray', id: 'tv_Hargray' },
  { label: 'Hawaiian Telcom', id: 'tv_hawaiian_telcom' },
  { label: 'Hotwire Communications', id: 'tv_hotwire_communications' },
  { label: 'Mediacom Cable', id: 'tv_mediacom_cable' },
  { label: 'Philo', id: 'tv_philo' },
  { label: 'Not Present', id: 'tv_not_present' },
  { label: 'O&O IT', id: 'tv_oo_it' },
  { label: 'Optimum By Cablevision', id: 'tv_optimum_by_cablevision' },
  { label: 'Other - In Notes', id: 'tv_other' },
  { label: 'RCN Rogers', id: 'tv_rcn_rogers' },
  { label: 'Sling TV', id: 'tv_sling_tv' },
  { label: 'Shaw', id: 'tv_shaw' },
  { label: 'Shaw Direct', id: 'tv_shaw_direct' },
  {
    label: 'Suddenlink Communications',
    id: 'tv_suddenlink_communications',
  },
  { label: 'Summit Broadband', id: 'tv_summit_broadband' },
  { label: 'Supported By 3rd Party', id: 'tv_supported_by_3rd_party' },
  { label: 'Telus', id: 'tv_telus' },
  { label: 'Tivo', id: 'tv_tivo' },
  { label: 'Vidgo', id: 'tv_vidgo' },
  { label: 'Verizon Fios', id: 'tv_verizon_fios' },
  { label: 'Wave Broadband', id: 'tv_wave_broadband' },
  { label: 'Windstream', id: 'tv_windstream' },
  { label: 'WOW!', id: 'tv_wow' },
  { label: 'XFINITY From Comcast', id: 'tv_xfinity_from_comcast' },
  { label: 'Xplornet', id: 'tv_xplornet' },
  { label: 'YouTubeTV', id: 'tv_youtubetv' },
].sort(sort);
export const remoteSystemManagement = [
  { label: 'Alarm.com', id: 'rsmtool_alarm.com' },
  { label: 'Alta Labs', id: 'rsmtool_alta_labs' },
  { label: 'Big Dog Power', id: 'rsmtool_big_dog_power' },
  { label: 'BakPak', id: 'rsmtool_bakpak' },
  { label: 'BlueBolt', id: 'rsmtool_bluebolt' },
  { label: 'Crestron XiO Cloud', id: 'rsmtool_crestron_xio_cloud' },
  { label: 'Domotz', id: 'rsmtool_domotz' },
  { label: 'Epic Mesh', id: 'rsmtool_epic_mesh' },
  { label: 'Eero Insights', id: 'rsmtool_eero_insights' },
  { label: 'Harmony Monitor', id: 'rsmtool_harmony_monitor' },
  { label: 'Josh.ai', id: 'rsmtool_josh_ai' },
  { label: 'Lutron Connect', id: 'rsmtool_lutron_connect' },
  { label: 'Luxul ProWatch', id: 'rsmtool_luxul_prowatch' },
  { label: 'MyCrestron', id: 'rsmtool_my_crestreon' },
  { label: 'OneVision', id: 'rsmtool_onevision' },
  { label: 'OvrC', id: 'rsmtool_ovrc' },
  { label: 'PolyLens', id: 'rsmtool_polylens' },
  { label: 'Ruckus Cloud', id: 'rsmtool_ruckus_cloud' },
  { label: 'RouteThis', id: 'rsmtool_routethis' },
  { label: 'Savant Central', id: 'rsmtool_savant_central' },
  { label: 'Parasol', id: 'rsmtool_parasol' },
  { label: 'UniFi', id: 'rsmtool_unifi' },
  { label: 'Not Present', id: 'rsmtool_not_present' },
].sort(sort);
export const audioSystemType = [
  { label: 'Supported By 3rd Party', id: 'audio_supported_by_3rd_party' },
  { label: 'Local', id: 'audio_local' },
  { label: 'Distributed', id: 'audio_distributed' },
  { label: 'Not Present', id: 'audio_not_present' },
].sort(sort);
export const primaryAudioInterface = [
  { label: 'AirPlay', id: 'audiosys_airplay' },
  { label: 'Auralic Lightning DS', id: 'audiosys_auralic_lightning_ds' },
  { label: 'Autonomic Controls', id: 'audiosys_autonomic_controls' },
  { label: 'Bang & Olufsen', id: 'audiosys_bang_and_olufsen' },
  { label: 'Control System', id: 'audiosys_control_system' },
  { label: 'Control4', id: 'audiosys_control4' },
  { label: 'Crestron', id: 'audiosys_crestron' },
  { label: 'Bluesound', id: 'audiosys_bluesound' },
  { label: 'DBX', id: 'audiosys_dbx' },
  { label: 'Denon Heos', id: 'audiosys_denon_heos' },
  { label: 'Elan/Nice', id: 'audiosys_elan_nice' },
  { label: 'Mood Media', id: 'audiosys_mood_media' },
  { label: 'Not Present', id: 'audiosys_not_present' },
  { label: 'Origin Acoustics', id: 'audiosys_origin_acoustics' },
  { label: 'Other - In Notes', id: 'audiosys_other' },
  { label: 'PlayNetwork', id: 'audiosys_playnetwork' },
  { label: 'Russound', id: 'audiosys_russound' },
  { label: 'Sonos', id: 'audiosys_sonos' },
  { label: 'Soundmachine', id: 'audiosys_soundmachine' },
  { label: 'Symmetrix', id: 'audiosys_symmetrix' },
  { label: 'Savant Music Server', id: 'audiosys_savant_music_server' },
  {
    label: 'Supported By 3rd Party',
    id: 'audiosys_supported_by_3rd_party',
  },
  { label: 'Symmetrix', id: 'audiosys_symmetrix' },
  { label: 'Wisdom Audio', id: 'audiosys_wisdom_audio' },
].sort(sort);
export const streamingPlatform = [
  { label: 'Apple TV', id: 'stream_apple_tv' },
  { label: 'Apple TV 4K', id: 'stream_apple_tv_4k' },
  { label: 'BluRay Player', id: 'stream_bluray_player' },
  { label: 'Dish Hopper', id: 'stream_dish_hopper' },
  { label: 'Fire Device', id: 'stream_fire_device' },
  { label: 'Foxtel', id: 'stream_foxtel' },
  { label: 'Google Chromecast', id: 'stream_google_chromecast' },
  { label: 'Google TV', id: 'stream_google_tv' },
  { label: 'Kaleidescape Strato', id: 'stream_kaleidescape_strato' },
  { label: 'Kaleidescape Terra', id: 'stream_kaleidescape_terra' },
  { label: 'K-Scape', id: 'stream_k-scape' },
  { label: 'Multiple Devices - See Org Note', id: 'stream_multiple' },
  { label: 'Nvidia Shield TV', id: 'stream_nvidia_shield_tv' },
  { label: 'PlayStation', id: 'stream_playstation' },
  { label: 'Plex', id: 'stream_plex' },
  { label: 'Roku', id: 'stream_roku' },
  { label: 'Smart TV', id: 'stream_smart_tv' },
  { label: 'Telstra TV', id: 'stream_telstra_tv' },
  { label: 'XBox', id: 'stream_xbox' },
  { label: 'Xfinity Flex', id: 'stream_xfinity_flex' },
  { label: 'YouTubeTV', id: 'stream_youtubetv' },
  { label: 'Other - In Notes', id: 'stream_other' },
].sort(sort);
export const videoSystemType = [
  {
    label: 'Supported By 3rd Party',
    id: 'video_system_supported_by_3rd_party',
  },
  { label: 'Local', id: 'video_system_local' },
  { label: 'Distributed', id: 'video_system_distributed' },
  { label: 'Other - In Notes', id: 'video_system_other' },
  { label: 'Not Present', id: 'video_system_not_present' },
  { label: 'HDMI balun', id: 'video_hdmi-balun' },
].sort(sort);
export const videoDistributionBrand = [
  { label: 'AudioControl', id: 'videosys_audiocontrol' },
  { label: 'Atlona', id: 'videosys_atlona' },
  { label: 'AVPro', id: 'videosys_avpro' },
  { label: 'AVPro Edge', id: 'videosys_avpr_edge' },
  { label: 'Barco Residential', id: 'videosys_barco_residential' },
  { label: 'Control4', id: 'videosys_control4' },
  { label: 'Crestron', id: 'videosys_crestron' },
  { label: 'Elan', id: 'videosys_elan' },
  { label: 'Just Video', id: 'videosys_just_video' },
  { label: 'JustAddPower', id: 'videosys_justaddpower' },
  { label: 'Lightware', id: 'videosys_lightware' },
  { label: 'Mirage', id: 'videosys_mirage' },
  { label: 'MOIP (Snap)', id: 'videosys_moip_snap' },
  { label: 'Not Present', id: 'videosys_not_present' },
  { label: 'Other - In Notes', id: 'videosys_other' },
  { label: 'PixelPro', id: 'videosys_pixelpro' },
  { label: 'Pulse8', id: 'videosys_pulse8' },
  { label: 'Savant', id: 'videosys_savant' },
  { label: 'Savant VOIP', id: 'videosys_savant_voip' },
  { label: 'SnapAV', id: 'videosys_snapav' },
  {
    label: 'Supported By 3rd Party',
    id: 'videosys_supported_by_3rd_party',
  },
  { label: 'VideoStorm', id: 'videosys_videostorm' },
  { label: 'Wyrestorm', id: 'videosys_wyrestorm' },
  { label: 'ZeeVee', id: 'videosys_zeevee' },
  { label: 'Binary (Snap AV)', id: 'videosys_binary' },
  { label: 'iConnects', id: 'videosys_iconnects' },
].sort(sort);
export const shadeType = [
  { label: 'Wired', id: 'shadetype_wired' },
  { label: 'Wireless', id: 'shadetype_wireless' },
  { label: 'Not Present', id: 'shadetype_not_present' },
  { label: 'Hybrid', id: 'Hybridshadetype_hybrid' },
].sort(sort);
export const shadeInterface = [
  { label: 'Control System', id: 'shades_control_system' },
  { label: 'Native Interface', id: 'shades_native_interface' },
  { label: 'Not Present', id: 'shades_not_present' },
].sort(sort);
export const shadeBrand = [
  { label: 'Acmeda Rollease', id: 'shadebrand_acmeda_rollease' },
  { label: 'Conrad', id: 'shadebrand_conrad' },
  { label: 'Crestron', id: 'shadebrand_crestron' },
  { label: 'Draper', id: 'shadebrand_draper' },
  { label: 'Geiger', id: 'shadebrand_geiger' },
  { label: 'J Geiger', id: 'shadebrand_j_geiger' },
  { label: 'Hartmann & Forbes', id: 'shadebrand_hartmann_and_forbes' },
  { label: 'Hunter Douglas', id: 'shadebrand_hunter_douglas' },
  { label: 'Innova', id: 'shadebrand_innova' },
  { label: 'Insolroll', id: 'shadebrand_insolroll' },
  { label: 'Lutron', id: 'shadebrand_lutron' },
  { label: 'Lutron Palladiom', id: 'shadebrand_lutron_palladiom' },
  { label: 'Lutron Triathlon', id: 'shadebrand_lutron_triathlon' },
  { label: 'Mechoshade', id: 'shadebrand_mechoshade' },
  { label: 'Not Present', id: 'shadebrand_not_present' },
  { label: 'Other - In Notes', id: 'shadebrand_other' },
  { label: 'QMotion', id: 'shadebrand_qmotion' },
  { label: 'Powershades', id: 'shadebrand_powershades' },
  { label: 'Savant', id: 'shadebrand_savant' },
  { label: 'Screen Innovations', id: 'shadebrand_screen_innovations' },
  { label: 'SmartWings', id: 'shadebrand_smart_wings' },
  {
    label: 'Solar Shading System ',
    id: 'shadebrand_solar_shading_system',
  },
  {
    label: 'Supported By 3rd Party',
    id: 'shadebrand_supported_by_3rd_party',
  },
  { label: 'Somfy', id: 'shadebrand_somfy' },
  { label: 'Skyco Shading', id: 'shadebrand_skyco_shading' },
  { label: 'Warema', id: 'shadebrand_warema' },
].sort(sort);
export const lightingSystemType = [
  {
    label: 'Supported By 3rd Party',
    id: 'lighting_supported_by_3rd_party',
  },
  { label: 'Centralized', id: 'lighting_centralized' },
  { label: 'Hybrid', id: 'lighting_hybrid' },
  { label: 'Wireless', id: 'lighting_wireless' },
  { label: 'Not Present', id: 'lighting_not_present' },
].sort(sort);
export const lightingBrand = [
  {
    label: 'Supported By 3rd Party',
    id: 'light_brand_supported_by_3rd_party',
  },
  { label: 'Basalte', id: 'light_brand_basalte' },
  { label: 'Control4', id: 'light_brand_control4' },
  { label: 'Crestron', id: 'light_brand_crestron' },
  { label: 'DMF Lighting', id: 'light_brand_dmf' },
  { label: 'Ketra', id: 'light_brand_ketra' },
  { label: 'Leviton - HomeKit', id: 'light_brand_leviton_homekit' },
  { label: 'Leviton - Industrial', id: 'light_brand_leviton_industrial' },
  { label: 'Leviton - WiFi', id: 'light_brand_leviton_wifi' },
  { label: 'Leviton - ZWave', id: 'light_brand_leviton_zwave' },
  { label: 'Lifx', id: 'light_brand_lifx' },
  { label: 'Lutron Caseta', id: 'light_brand_lutron_caseta' },
  { label: 'Lutron Grafik Eye', id: 'light_brand_lutron_grafik_eye' },
  { label: 'Lutron QSX', id: 'light_brand_lutron_qsx' },
  {
    label: 'Lutron Homeworks Illumination',
    id: 'light_brand_lutron_homeworks_illumination',
  },
  { label: 'Lutron Homeworks QS', id: 'light_brand_lutron_homeworks_qs' },
  { label: 'Lutron RadioRA 2', id: 'light_brand_lutron_radiora_2' },
  { label: 'Lutron RadioRA 3', id: 'light_brand_lutron_radiora_3' },
  { label: 'Lutron Vive', id: 'light_brand_lutron_vive' },
  { label: 'Lutron Ketra', id: 'light_brand_lutron_ketra' },
  { label: 'Noon Home', id: 'light_brand_noon_home' },
  { label: 'Phillips Hue', id: 'light_brand_phillips_hue' },
  { label: 'Pharos Controls', id: 'light_brand_pharos_controls' },
  { label: 'Proluxe Lighting', id: 'light_brand_proluxe' },
  { label: 'USAi Lighting', id: 'light_brand_usai_lighting' },
  { label: 'Savant', id: 'light_brand_savant' },
  { label: 'SmartThings', id: 'light_brand_smartthings' },
  { label: 'Vantage LHUMAN', id: 'light_brand_vantage_lhuman' },
  { label: 'URC Vivido', id: 'light_brand_urc_vivido' },
  { label: 'Vantage Infusion', id: 'light_brand_vantage_infusion' },
  { label: 'Vantage Q Series', id: 'light_brand_vantage_q_series' },
  { label: 'Other - In Notes', id: 'light_brand_other' },
  { label: 'Not Present', id: 'light_brand_not_present' },
  { label: 'Crestron Pyng', id: 'light_brand_crestron_pyng' },
  { label: 'Lutron RA2 Select', id: 'light_brand_lutron_ra2_select' },
  { label: 'WAC Lighting', id: 'light_brand_wac' },
  { label: 'LumaStream', id: 'light_brand_lumastream' },
].sort(sort);
export const accessControlSystemSmartLocks = [
  { label: '2n', id: 'acs_2n' },
  { label: 'August Lock', id: 'acs_august_lock' },
  { label: 'Baldwin Door Locks', id: 'acs_baldwin_door_locks' },
  { label: 'ButterflyMX', id: 'acs_butterflymx' },
  { label: 'Brivo', id: 'acs_brivo' },
  { label: 'Danalock', id: 'acs_danalock' },
  { label: 'DoorBird', id: 'acs_doorbird' },
  { label: 'DoorKing', id: 'acs_doorking' },
  { label: 'Electric Strikes', id: 'acs_electric_strikes' },
  { label: 'Kantech', id: 'acs_kantech' },
  { label: 'Latch', id: 'acs_latch' },
  { label: 'Kwikset', id: 'acs_kwikset' },
  { label: 'Not Present', id: 'acs_not_present' },
  { label: 'Other - In Notes', id: 'acs_other' },
  { label: 'Ring DoorBell', id: 'acs_ring_doorbell' },
  { label: 'Schlage', id: 'acs_schlage' },
  { label: 'Salto', id: 'acs_salto' },
  { label: 'Sesame', id: 'acs_sesame' },
  { label: 'Supported By 3rd Party', id: 'acs_supported_by_3rd_party' },
  { label: 'Ubiquiti', id: 'acs_ubiquiti' },
  { label: 'Yale', id: 'acs_yale' },
].sort(sort);
export const hvacIntegration = [
  {
    label: 'Supported By 3rd Party',
    id: 'hvac_integration_supported_by_3rd_party',
  },
  { label: 'Yes', id: 'hvac_integration_yes' },
  { label: 'Not Present', id: 'hvac_integration_not_present' },
].sort(sort);
export const hvacBrand = [
  { label: '2GIG', id: 'hvac_2gig' },
  { label: 'Alarm.com', id: 'hvac_alarm.com' },
  { label: 'Allure', id: 'hvac_allure' },
  { label: 'Aprilaire', id: 'hvac_aprilaire' },
  { label: 'Control4', id: 'hvac_control4' },
  { label: 'Cool Automation', id: 'hvac_cool_automation' },
  { label: 'Crestron', id: 'hvac_crestron' },
  { label: 'Daikin VRV', id: 'hvac_daikin_vrv' },
  { label: 'Daikin', id: 'hvac_daikin' },
  { label: 'Ecobee', id: 'hvac_ecobee' },
  { label: 'Emerson', id: 'hvac_emerson' },
  { label: 'Fujitsu', id: 'hvac_fujitsu' },
  { label: 'Honeywell', id: 'hvac_honeywell' },
  { label: 'Iris', id: 'hvac_iris' },
  { label: 'Leviton', id: 'hvac_leviton' },
  { label: 'LG', id: 'hvac_lg' },
  { label: 'Lutron', id: 'hvac_lutron' },
  { label: 'Lux', id: 'hvac_lux' },
  { label: 'Mitsubishi', id: 'hvac_mitsubishi' },
  { label: 'Modbus BMS', id: 'hvac_modbus_bms' },
  { label: 'Nest', id: 'hvac_nest' },
  { label: 'Not Present', id: 'hvac_not_present' },
  { label: 'Other - In Notes', id: 'hvac_other' },
  { label: 'Panasonic', id: 'hvac_panasonic' },
  { label: 'Savant', id: 'hvac_savant' },
  { label: 'Supported By 3rd Party', id: 'hvac_supported_by_3rd_party' },
  { label: 'Systemair', id: 'hvac_systemair' },
  { label: 'Trane', id: 'hvac_trane' },
  { label: 'Tekmar', id: 'hvac_tekmar' },
  { label: 'Wiser', id: 'hvac_wiser' },
].sort(sort);
export const videoDoorbells = [
  { label: '2N', id: 'doorbell_2n' },
  { label: 'Alarm.com', id: 'doorbell_alarm_com' },
  { label: 'August', id: 'doorbell_august' },
  { label: 'ButterflyMX', id: 'doorbell_butterflymx' },
  { label: 'Channel Vision', id: 'doorbell_channel_vision' },
  { label: 'Control4', id: 'doorbell_control4' },
  { label: 'Custom', id: 'doorbell_custom' },
  { label: 'Doorbird', id: 'doorbell_doorbird' },
  { label: 'Holovision', id: 'doorbell_holovision' },
  { label: 'Lilin', id: 'doorbell_lilin' },
  { label: 'Nest', id: 'doorbell_nest' },
  { label: 'Not Present', id: 'doorbell_not_present' },
  { label: 'Ring', id: 'doorbell_ring' },
  { label: 'Savant', id: 'doorbell_savant' },
  { label: 'Siedle', id: 'doorbell_siedle' },
  { label: 'Skybell', id: 'doorbell_skybell' },
  { label: 'Swann', id: 'doorbell_swann' },
  { label: 'Ubiquiti', id: 'doorbell_ubiquiti' },
  { label: 'Vivint', id: 'doorbell_vivint' },
  { label: 'Other - In Notes', id: 'doorbell_other' },
  {
    label: 'Supported By 3rd Party',
    id: 'doorbell_supported_by_3rd_party',
  },
].sort(sort);
export const phoneSystemType = [
  { label: 'Supported By 3rd Party', id: 'phones_supported_by_3rd_party' },
  { label: 'Basic', id: 'phones_basic' },
  { label: 'Digital/PBX (with server)', id: 'phones_digitalpbx' },
  { label: 'VoIP (w/o server)', id: 'phones_voip' },
  { label: 'Not Present', id: 'phones_not_present' },
].sort(sort);
export const phoneBrand = [
  {
    label: 'Supported By 3rd Party',
    id: 'phone_brand_supported_by_3rd_party',
  },
  { label: 'Aastra', id: 'phone_brand_aastra' },
  { label: 'Ameriphone', id: 'phone_brand_ameriphone' },
  { label: 'AT&T', id: 'phone_brand_at&t' },
  { label: 'Avaya', id: 'phone_brand_avaya' },
  { label: 'Bell Phones', id: 'phone_brand_bell_phones' },
  { label: 'Cisco', id: 'phone_brand_cisco' },
  { label: 'ClearOne', id: 'phone_brand_clearone' },
  { label: 'GE', id: 'phone_brand_ge' },
  { label: 'Motorola', id: 'phone_brand_motorola' },
  { label: 'NEC', id: 'phone_brand_nec' },
  { label: 'Panasonic', id: 'phone_brand_panasonic' },
  { label: 'Philips', id: 'phone_brand_philips' },
  { label: 'Polycom', id: 'phone_brand_polycom' },
  { label: 'RCA', id: 'phone_brand_rca' },
  { label: 'RingCentral', id: 'phone_brand_ringcentral' },
  { label: 'Siemens', id: 'phone_brand_siemens' },
  { label: 'Sony', id: 'phone_brand_sony' },
  { label: 'Uniden', id: 'phone_brand_uniden' },
  { label: 'Vtech', id: 'phone_brand_vtech' },
  { label: 'Other - In Notes', id: 'phone_brand_other' },
  { label: 'Not Present', id: 'phone_brand_not_present' },
  {
    label: 'Hotwire Communications',
    id: 'phone_brand_hotwire_communications',
  },
  { label: 'Grandstream', id: 'phone_brand_grandstream' },
].sort(sort);
export const intercom = [
  {
    label: 'Supported By 3rd Party',
    id: 'intercom_supported_by_3rd_party',
  },
  { label: '2N', id: 'intercom_2n' },
  { label: 'Aiphone', id: 'intercom_aiphone' },
  { label: 'AT&T', id: 'intercom_att' },
  { label: 'Avaya', id: 'intercom_avaya' },
  { label: 'C3X', id: 'intercom_c3x' },
  { label: 'Cisco', id: 'intercom_cisco' },
  { label: 'Clear One', id: 'intercom_clear_one' },
  { label: 'Control4', id: 'intercom_control4' },
  { label: 'Crestron', id: 'intercom_crestron' },
  { label: 'Digium', id: 'intercom_digium' },
  { label: 'Elan', id: 'intercom_elan' },
  { label: 'Holovision', id: 'intercom_holovision' },
  { label: 'Intrasonic Intercoms', id: 'intercom_intrasonic_intercoms' },
  { label: 'Legrand', id: 'intercom_legrand' },
  { label: 'M&S', id: 'intercom_m&s' },
  { label: 'Mitel', id: 'intercom_mitel' },
  { label: 'NEC', id: 'intercom_nec' },
  { label: 'On-Q', id: 'intercom_on-q' },
  { label: 'Panasonic', id: 'intercom_panasonic' },
  { label: 'Polycom', id: 'intercom_polycom' },
  { label: 'RCA', id: 'intercom_rca' },
  { label: 'Savant', id: 'intercom_savant' },
  { label: 'Siedle', id: 'intercom_siedle' },
  { label: 'Ubiquity', id: 'intercom_ubiquity' },
  { label: 'Viking', id: 'intercom_viking' },
  { label: 'Not Present', id: 'intercom_not_present' },
  { label: 'Other - In Notes', id: 'intercom_other' },
].sort(sort);
export const securitySystemIntegrated = [
  { label: 'Integrated', id: 'securityintegrated_integrated' },
  { label: 'Not Integrated', id: 'securityintegrated_not_integrated' },
  { label: 'Not Present', id: 'securityintegrated_not_present' },
].sort(sort);
export const securitySystemBrand = [
  {
    label: 'Supported By 3rd Party',
    id: 'security_supported_by_3rd_party',
  },
  { label: 'Ademco Vista', id: 'security_ademco_vista' },
  { label: '2GIG', id: 'security_2gig' },
  { label: 'ADT Pulse', id: 'security_adt_pulse' },
  { label: 'Bosch', id: 'security_bosch' },
  { label: 'Concord 4', id: 'security_concord-4' },
  { label: 'DSC', id: 'security_dsc' },
  { label: 'DMP', id: 'security_dmp' },
  { label: 'GE', id: 'security_ge' },
  { label: 'HAI/Leviton', id: 'security_hai/leviton' },
  { label: 'Interlogix', id: 'security_interlogix' },
  { label: 'LenelS2', id: 'security_lenels2' },
  { label: 'Gallagher', id: 'security_gallagher' },
  { label: 'Qolsys', id: 'security_qolsys' },
  { label: 'Vivint', id: 'security_vivint' },
  { label: 'Other - In Notes', id: 'security_other' },
  { label: 'Not Present', id: 'security_not_present' },
  { label: 'Alarm.com', id: 'security_alarm.com' },
  { label: 'Elk', id: 'security_elk' },
  { label: 'Honeywell', id: 'security_honeywell' },
  { label: 'Honeywell Vista', id: 'security_honeywell_vista' },
  { label: 'Luma', id: 'security_luma' },
  { label: 'NapCo', id: 'security_napco' },
  { label: 'Clare Controls', id: 'security_clare-controls' },
  { label: 'Ring', id: 'security_ring' },
  { label: 'Siedle Access', id: 'security_siedle_access' },
].sort(sort);
export const cameraSystemType = [
  {
    label: 'Supported By 3rd Party',
    id: 'camera_system_supported_by_3rd_party',
  },
  { label: 'Direct-to-Camera', id: 'camera_system_direct-to-camera' },
  { label: 'On-Site NVR', id: 'camera_system_on-site_nvr' },
  { label: 'Cloud-Based', id: 'camera_system_cloud-based' },
].sort(sort);
export const cameraSystemBrand = [
  { label: 'Avigilon', id: 'cambrand_avigilon' },
  { label: 'Arlo', id: 'cambrand_arlo' },
  { label: 'Alarm.com', id: 'cambrand_alarm.com' },
  { label: 'Bosch', id: 'cambrand_bosch' },
  { label: 'Axis', id: 'cambrand_axis' },
  { label: 'Dahua', id: 'cambrand_dahua' },
  { label: 'Digital Watchdog', id: 'cambrand_digital_watchdog' },
  { label: 'Eagle Eye Networks', id: 'cambrand_eagle_eye_networks' },
  { label: 'Flir', id: 'cambrand_flir' },
  { label: 'Hanwha', id: 'cambrand_hanwha' },
  { label: 'Hanwha Vision', id: 'cambrand_hanwha_vision' },
  { label: 'Hikvision', id: 'cambrand_hikvision' },
  { label: 'ICRealtime', id: 'cambrand_icrealtime' },
  { label: 'Leviton', id: 'cambrand_leviton' },
  { label: 'Lilin', id: 'cambrand_lilin' },
  { label: 'Luma (SnapAV)', id: 'cambrand_luma_snapav' },
  { label: 'Meraki', id: 'cambrand_meraki' },
  { label: 'Mobotix', id: 'cambrand_mobotix' },
  { label: 'Nest', id: 'cambrand_nest' },
  { label: 'Nice/Elan', id: 'cambrand_nice_elan' },
  { label: 'Not Present', id: 'cambrand_not_present' },
  { label: 'LTS', id: 'cambrand_lts' },
  { label: 'Nuuo', id: 'cambrand_nuuo' },
  { label: 'Other - In Notes', id: 'cambrand_other' },
  { label: 'ProvisionISR', id: 'cambrand_provisionisr' },
  { label: 'Panasonic i-PRO', id: 'cambrand_panasonic_ipro' },
  { label: 'Pelco', id: 'cambrand_pelco' },
  { label: 'Rhombus', id: 'cambrand_rhombus' },
  { label: 'Ubiquiti CCTV', id: 'cambrand_ubiquiti_cctv' },
  { label: 'Ring', id: 'cambrand_ring' },
  { label: 'Speco', id: 'cambrand_speco' },
  { label: 'Sony', id: 'cambrand_sony' },
  { label: 'Turing', id: 'cambrand_turing' },
  {
    label: 'Supported By 3rd Party',
    id: 'cambrand_supported_by_3rd_party',
  },
  { label: 'Synology', id: 'cambrand_synology' },
  { label: 'Visualint', id: 'cambrand_visualint' },
  { label: 'Vivotek', id: 'cambrand_vivotek' },
  { label: 'Verkada', id: 'cambrand_verkada' },
  { label: 'Wirepath (SnapAV)', id: 'cambrand_wirepath_snapav' },
  { label: 'Uniview', id: 'cambrand_uniview' },
].sort(sort);

export const systemInfrastructure = [
  {
    type: 'autocomplete' as const,
    name: 'sitePrimaryEquipmentLocation' as const,
    label: 'Primary Equipment Location',
    required: 'Primary Equipment Location is required',
    options: primaryEquipmentLocation,
  },
  {
    type: 'autocomplete' as const,
    name: 'siteNetworkLocation' as const,
    label: 'Network Location',
    required: 'Network Location is required',
    options: networkLocation,
  },
  {
    type: 'autocomplete' as const,
    name: 'siteWiredNetworkBrand' as const,
    label: 'Wired Network Brand',
    required: 'Wired Network Brand is required',
    options: wiredNetworkBrand,
  },
  {
    type: 'autocomplete' as const,
    name: 'siteWirelessNetworkBrand' as const,
    label: 'Wireless Network Brand',
    required: 'Wireless Network Brand is required',
    options: wirelessNetworkBrand,
  },
  {
    type: 'autocomplete' as const,
    name: 'site3rdPartyNetworkProvider' as const,
    label: '3rd Party Network Provider',
    required: '3rd Party Network Provider is required',
    options: thirdPartyNetworkProvider,
  },
  {
    type: 'autocomplete' as const,
    name: 'siteInternetService' as const,
    label: 'Internet Service Provider',
    required: 'Internet Service Provider is required',
    options: internetServiceProvider,
  },
];

export const subSystems = [
  {
    header: 'Remote Systems Management',
    fields: [
      {
        label: 'Primary Brand',
        name: 'siteRemoteSystemsManagement',
        options: remoteSystemManagement,
        icon: {
          name: 'siteRsmUrl',
        },
      },
      {
        label: 'Primary RSM URL',
        name: 'siteRsmUrl',
        showOnlyWithCondition: true,
        pattern: urlPattern,
      },
      {
        label: 'Secondary Brand',
        name: 'siteSecondaryRemoteSystemsManagement',
        options: remoteSystemManagement,
        icon: {
          name: 'siteSecondaryRsmUrl',
        },
      },
      {
        label: 'Secondary RSM URL',
        name: 'siteSecondaryRsmUrl',
        showOnlyWithCondition: true,
        pattern: urlPattern,
      },
      {
        label: 'Tertiary Brand',
        name: 'siteTertiaryRemoteSystemsManagement',
        options: remoteSystemManagement,
        icon: {
          name: 'siteTertiaryRsmUrl',
        },
      },
      {
        label: 'Tertiary RSM URL',
        name: 'siteTertiaryRsmUrl',
        showOnlyWithCondition: true,
        pattern: urlPattern,
      },
      {
        label: 'Is Monitored',
        name: 'isMonitored',
        type: 'switch' as const,
      },
      {
        label: 'RSM Notes',
        name: 'rsmNotes',
        type: 'rich-text-bubble' as const,
        placeholder: 'Notes about the Remote Systems Management tools',
        debounced: SAVE_DEBOUNCE_DELAY,
      },
    ],
  },
  {
    header: 'TV',
    fields: [
      {
        label: 'Service Provider',
        name: 'siteTvServiceProvider',
        options: tvServiceProvider,
      },
    ],
  },
  {
    header: 'Control System',
    fields: [
      {
        label: 'Brand',
        name: 'siteControlSystemBrand',
        options: controlSystemBrand,
      },
    ],
  },
  {
    header: 'Shades',
    fields: [
      {
        label: 'Type',
        name: 'siteShadeType',
        options: shadeType,
      },
      {
        label: 'Interface',
        name: 'siteShadeInterface',
        options: shadeInterface,
      },
      {
        label: 'Brand',
        name: 'siteShadeBrand',
        options: shadeBrand,
      },
    ],
  },
  {
    header: 'Security System',
    fields: [
      {
        label: 'Security System Integrated',
        name: 'siteSecuritySystemIntegrated',
        options: securitySystemIntegrated,
      },
      {
        label: 'Security System Brand',
        name: 'siteSecuritySystemBrand',
        options: securitySystemBrand,
      },
      {
        label: 'Camera Type',
        name: 'siteCameraSystemType',
        options: cameraSystemType,
      },
      {
        label: 'Camera Brand',
        name: 'siteCameraSystemBrand',
        options: cameraSystemBrand,
      },
    ],
  },
  {
    header: 'HVAC',
    fields: [
      {
        label: 'Integration',
        name: 'hvacIntegration',
        options: hvacIntegration,
      },
      {
        label: 'Brand',
        name: 'siteHvacBrand',
        options: hvacBrand,
      },
    ],
  },
  {
    header: 'Streaming Platform',
    fields: [
      {
        label: 'Brand',
        name: 'siteStreamingPlatform',
        options: streamingPlatform,
      },
    ],
  },
  {
    header: 'Access Controls & Smart Locks',
    fields: [
      {
        label: 'Brand',
        name: 'siteAccessControlSystemSmartLocks',
        options: accessControlSystemSmartLocks,
      },
    ],
  },
  {
    header: 'Audio',
    fields: [
      {
        label: 'System Type',
        name: 'siteAudioSystemType',
        options: audioSystemType,
      },
      {
        label: 'Primary Interface',
        name: 'sitePrimaryAudioInterface',
        options: primaryAudioInterface,
      },
    ],
  },
  {
    header: 'Video',
    fields: [
      {
        label: 'System Type',
        name: 'siteVideoSystemType',
        options: videoSystemType,
      },
      {
        label: 'Brand',
        name: 'siteVideoDistributionBrand',
        options: videoDistributionBrand,
      },
    ],
  },
  {
    header: 'Lighting',
    fields: [
      {
        label: 'System Type',
        name: 'siteLightingSystemType',
        options: lightingSystemType,
      },
      {
        label: 'Brand',
        name: 'siteLightingSystemBrand',
        options: lightingBrand,
      },
    ],
  },
  {
    header: 'Phone',
    fields: [
      {
        label: 'System Type',
        name: 'sitePhoneSystemType',
        options: phoneSystemType,
      },
      {
        label: 'Brand',
        name: 'sitePhoneSystemBrand',
        options: phoneBrand,
      },
    ],
  },
  {
    header: 'Intercom',
    fields: [
      {
        label: 'Brand',
        name: 'siteIntercom',
        options: intercom,
      },
    ],
  },
  {
    header: 'Doors',
    fields: [
      {
        label: 'Video Doorbells Brand',
        name: 'siteVideoDoorbell',
        options: videoDoorbells,
      },
    ],
  },
];
